import type { IconComponent as AppIconComponent } from '@/components/ui/icon';
import { icons } from 'lucide-react';

export type { IconComponent as AppIconComponent } from '@/components/ui/icon';

/*
 * Exported so feature modules can name a Lucide glyph that has no fa*
 * alias yet without adding a one-line export per icon. New severities
 * (risk-severity-presentation) needed ChevronsUp/Diamond before they
 * earned aliases; prefer adding an alias when a glyph gains a second
 * consumer.
 */
export const iconByName = <T extends keyof typeof icons>(
  name: T
): AppIconComponent => icons[name] as AppIconComponent;

export const faAddressBook = iconByName('ContactRound');
export const faAmazon = iconByName('Globe');
export const faAngleDown = iconByName('ChevronDown');
export const faAngleUp = iconByName('ChevronUp');
export const faAnglesUpDown = iconByName('ChevronsUpDown');
export const faBan = iconByName('Ban');
export const faArrowLeft = iconByName('ArrowLeft');
export const faArrowRight = iconByName('ArrowRight');
export const faArrowRightFromBracket = iconByName('LogOut');
export const faArrowTurnDownRight = iconByName('CornerDownRight');
export const faArrowTurnUp = iconByName('CornerUpRight');
export const faArchive = iconByName('Archive');
export const faArrowsLeftRight = iconByName('ArrowLeftRight');
export const faArrowsRotate = iconByName('RefreshCw');
export const faBarsFilter = iconByName('ListFilter');
export const faBell = iconByName('Bell');
export const faBellSlash = iconByName('BellOff');
export const faBirthdayCake = iconByName('Cake');
export const faBitcoin = iconByName('Bitcoin');
export const faBomb = iconByName('Bomb');
export const faBookOpen = iconByName('BookOpen');
export const faBox = iconByName('Box');
export const faBoxOpen = iconByName('PackageOpen');
export const faBriefcase = iconByName('Briefcase');
export const faBuilding = iconByName('Building');
export const faBuildingColumns = iconByName('Landmark');
export const faCalendar = iconByName('Calendar');
export const faCar = iconByName('Car');
export const faCarBurst = iconByName('CarFront');
export const faChartLine = iconByName('ChartLine');
export const faChartNetwork = iconByName('ChartNetwork');
export const faCheck = iconByName('Check');
export const faCheckCircle = iconByName('CircleCheck');
export const faChevronDown = iconByName('ChevronDown');
export const faChevronRight = iconByName('ChevronRight');
export const faChevronUp = iconByName('ChevronUp');
export const faCircleCheck = iconByName('CircleCheck');
export const faCircleExclamation = iconByName('CircleAlert');
export const faCircleInfo = iconByName('BadgeInfo');
export const faCircleSmall = iconByName('CircleSmall');
export const faCircleX = iconByName('CircleX');
export const faCircleXmark = iconByName('CircleX');
export const faCirclesOverlap = iconByName('Combine');
export const faClipboardList = iconByName('ClipboardList');
export const faClose = iconByName('X');
export const faCode = iconByName('Code');
export const faCommand = iconByName('Command');
export const faCopy = iconByName('Copy');
export const faCornerDownLeft = iconByName('CornerDownLeft');
export const faDatabase = iconByName('Database');
export const faDice = iconByName('Dices');
export const faDownload = iconByName('Download');
export const faEarthAmericas = iconByName('Earth');
export const faEdit = iconByName('Pencil');
export const faEllipsisVertical = iconByName('EllipsisVertical');
export const faEnvelope = iconByName('Mail');
export const faExclamationTriangle = iconByName('TriangleAlert');
export const faExternalLink = iconByName('ExternalLink');
export const faExpand = iconByName('Expand');
export const faEye = iconByName('Eye');
export const faEyeSlash = iconByName('EyeOff');
export const faFaceFrownSlight = iconByName('Frown');
export const faFaceMeh = iconByName('Meh');
export const faFaceSmile = iconByName('Smile');
export const faFaceViewfinder = iconByName('ScanSearch');
export const faFacebook = iconByName('Facebook');
export const faFile = iconByName('File');
export const faFileAlt = iconByName('FileText');
export const faFileArrowDown = iconByName('FileDown');
export const faFileCode = iconByName('FileCode');
export const faFileCsv = iconByName('FileSpreadsheet');
export const faFileDownload = iconByName('FileDown');
export const faFileLines = iconByName('FileText');
export const faFilePdf = iconByName('FileText');
export const faFileShield = iconByName('FileCheck');
export const faFilter = iconByName('ListFilter');
export const faFire = iconByName('Flame');
export const faFlag = iconByName('Flag');
export const faFlickr = iconByName('Globe');
export const faFolderOpen = iconByName('FolderOpen');
export const faFolderPlus = iconByName('FolderPlus');
export const faFoursquare = iconByName('Globe');
export const faFunnelDollar = iconByName('CircleDollarSign');
export const faGavel = iconByName('Gavel');
export const faGem = iconByName('Gem');
export const faGlobeAmericas = iconByName('Globe');
export const faGooglePlusG = iconByName('Globe');
export const faGrav = iconByName('Globe');
export const faGrid = iconByName('LayoutGrid');
export const faGripVertical = iconByName('GripVertical');
export const faGitBranchPlus = iconByName('GitBranchPlus');
export const faHammer = iconByName('Hammer');
export const faHandFist = iconByName('HandFist');
export const faHandHoldingDollar = iconByName('HandCoins');
export const faHandHoldingHeart = iconByName('HeartHandshake');
export const faHeadset = iconByName('Headset');
export const faHistory = iconByName('History');
export const faHouse = iconByName('House');
export const faRotateLeft = iconByName('RotateCcw');
export const faHourglassHalf = iconByName('Hourglass');
export const faIdBadge = iconByName('IdCardLanyard');
export const faIdCard = iconByName('IdCard');
export const faInfoCircle = iconByName('Info');
export const faInstagram = iconByName('Instagram');
export const faKey = iconByName('Key');
export const faLaptop = iconByName('Laptop');
export const faLeaf = iconByName('Leaf');
export const faLifeRing = iconByName('LifeBuoy');
export const faLink = iconByName('Link');
export const faLinkedin = iconByName('Linkedin');
export const faListAlt = iconByName('ClipboardList');
export const faListCheck = iconByName('ListCheck');
export const faLocationDot = iconByName('MapPin');
export const faLock = iconByName('Lock');
export const faMagnifyingGlassMinus = iconByName('SearchX');
export const faMegaphone = iconByName('Megaphone');
export const faMessagePlus = iconByName('MessageSquarePlus');
export const faMinus = iconByName('Minus');
export const faMinusCircle = iconByName('CircleMinus');
export const faMoneyBillWave = iconByName('Banknote');
export const faMoneyCheck = iconByName('CreditCard');
export const faMonitor = iconByName('Monitor');
export const faMoon = iconByName('Moon');
export const faMousePointer = iconByName('MousePointer2');
export const faNewspaper = iconByName('Newspaper');
export const faObjectsColumn = iconByName('Columns3');
export const faPaintbrush = iconByName('Paintbrush');
export const faPalette = iconByName('Palette');
export const faPencil = iconByName('Pencil');
export const faPencilAlt = iconByName('PencilLine');
export const faPhone = iconByName('Phone');
export const faPinterest = iconByName('Globe');
export const faPlugCircleXmark = iconByName('Unplug');
export const faPlus = iconByName('Plus');
export const faPlusCircle = iconByName('CirclePlus');
export const faQuestion = iconByName('CircleQuestionMark');
export const faQuestionCircle = iconByName('CircleQuestionMark');
export const faReceipt = iconByName('Receipt');
export const faRectangleList = iconByName('ClipboardList');
export const faRightFromBracket = iconByName('LogOut');
export const faSave = iconByName('Save');
export const faSearch = iconByName('Search');
export const faSearchMinus = iconByName('SearchX');
export const faSparkles = iconByName('Sparkles');
export const faShieldCheck = iconByName('ShieldCheck');
export const faShieldAlert = iconByName('ShieldAlert');
export const faShieldHalved = iconByName('ShieldHalf');
export const faShrink = iconByName('Shrink');
export const faSkullCrossbones = iconByName('Skull');
export const faSliders = iconByName('SlidersVertical');
export const faSlidersUp = iconByName('SlidersHorizontal');
export const faSpinner = iconByName('LoaderCircle');
export const faSquareMinus = iconByName('SquareMinus');
export const faSquarePlus = iconByName('SquarePlus');
export const faStar = iconByName('Star');
export const faStickyNote = iconByName('StickyNote');
export const faSync = iconByName('RefreshCw');
export const faSyringe = iconByName('Syringe');
export const faSun = iconByName('Sun');
export const faTable = iconByName('Table');
export const faTags = iconByName('Tags');
export const faThumbtack = iconByName('Pin');
export const faTimesCircle = iconByName('CircleX');
export const faTrash = iconByName('Trash');
export const faTrashAlt = iconByName('Trash2');
export const faTriangleExclamation = iconByName('TriangleAlert');
export const faTwitter = iconByName('Twitter');
export const faUniversity = iconByName('University');
export const faUnlink = iconByName('Unlink');
export const faUnlock = iconByName('LockOpen');
export const faUpload = iconByName('Upload');
export const faUser = iconByName('User');
export const faUserCircle = iconByName('CircleUserRound');
export const faUserMagnifyingGlass = iconByName('UserRoundSearch');
export const faUserPlus = iconByName('UserPlus');
export const faUserSecret = iconByName('ShieldUser');
export const faUsers = iconByName('Users');
export const faVenusMars = iconByName('VenusAndMars');
export const faVimeo = iconByName('Globe');
export const faWarning = iconByName('TriangleAlert');
export const faWebhook = iconByName('Webhook');
export const faX = iconByName('X');
export const faXmark = iconByName('X');
